import { ReactNode } from "react";

enum ViewActions {
    LOAD_PAGE = "loadPage",
    SEARCH_STRING = "searchString",
    INPUT_FIELD_STATE = "inputFieldState",
    RESET = "reset",
}

export interface ViewAction {
    type: `${ViewActions}`;
    payload: any;
}

export interface GenericItem {
    id: number;
    name: string;
    updated: string;
    configuration: any;
    isGlobal: boolean;
}

export interface ViewState {
    data: GenericItem[];
    lastLoadedPageData: any;
    searchString: string;
    inputFieldState: string;
}

export interface NameFormData {
    name: string;
}

export enum DialogActions {
    CONFIGURE_FORM = "configureForm",
    RESET = "reset",
}

type DialogPayloads = {
    [DialogActions.RESET]: undefined;
    [DialogActions.CONFIGURE_FORM]: DialogState;
};

export interface DialogAction<T extends DialogActions> {
    type: T;
    payload: DialogPayloads[T];
}

export type AllDialogActions = {
    [K in DialogActions]: DialogAction<K>;
};

export interface DialogState {
    title: ReactNode;
    isOpenDialog: boolean;
    onClose: () => void;
    onCancel: () => void;
    onSubmit: (data: NameFormData) => Promise<void>;
    initData?: NameFormData;
}
